


















import { Component, Emit, Prop, Mixins } from "vue-property-decorator"
import { mapState } from "vuex"
import api from "../../honcierge-api"
import ProcessingMixin from "../../mixins/processing-mixin"
import { Category, SubCategory } from "types/index"
import { ArticleState } from "src/store/articleType"

@Component({
  computed: {
    ...mapState("article", {
      categories: (state) => (state as ArticleState).categories,
    }),
  },
})
export default class MainSubCategorySearchForm extends Mixins(ProcessingMixin) {
  @Prop({ default: true })
  private enableName!: boolean
  private categories!: Category["view"][]

  private name = ""
  private result: SubCategory["view"][] = []

  @Emit("resetPagination")
  public emitResetPagination(): void {
    /* */
  }
  @Emit("resetSelection")
  public emitResetSelection(): void {
    /* */
  }
  @Emit("searchResult")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private searchResult(result: SubCategory["view"][], totalPages: number) {
    /* */
  }

  public reset() {
    this.name = ""
    this.result.length = 0
  }

  public async search(page = 1, sortBy = "id", descending = false) {
    this.startProcess()

    try {
      const response = await api.getSubCategories({
        categoryIds: this.categories.map((category) => category.id),
        excludeIds: null,
        name: this.name,
        sortBy,
        descending,
        page,
        per: 10,
        includeDisabled: false,
        fields: ["id", "name"],
        withCategory: true,
        breadcrumbStatuses: ["default", "main"],
      })
      this.result = response.data.subCategories
      this.searchResult(
        response.data.subCategories.length > 0 ? this.result : [],
        response.data.meta.totalPages
      )
    } catch {
      this.$toasted.error("パンくず小カテゴリーの取得に失敗しました")
    } finally {
      this.endProcess()
    }
  }
}
